var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-content"},[_c('img',{staticClass:"footer-image",attrs:{"src":require("@/assets/index-bottom.png"),"alt":"footer-left"}}),_c('img',{staticClass:"footer-image footer-image-right",attrs:{"src":require("@/assets/index-bottom.png"),"alt":"footer-right"}})])])
}]

export { render, staticRenderFns }